import { render, staticRenderFns } from "./FlagshipProjects.vue?vue&type=template&id=2e620626&scoped=true"
import script from "./FlagshipProjects.vue?vue&type=script&lang=js"
export * from "./FlagshipProjects.vue?vue&type=script&lang=js"
import style0 from "./FlagshipProjects.vue?vue&type=style&index=0&id=2e620626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e620626",
  null
  
)

export default component.exports